import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill="#243E81" d="M12 0a12 12 0 1 1 0 24 12 12 0 0 1 0-24"/> <path fill="#fff" fill-opacity=".5" d="M12 0a12 12 0 1 1 0 24 12 12 0 0 1 0-24"/> <path fill="#fff" d="M16.662 7.67a5.7 5.7 0 0 1-1.077.092 8 8 0 0 1-3.325-.708l-.277-.123-.062.03-.215.093a8.1 8.1 0 0 1-3.325.708q-.54.006-1.077-.062l-.831-.184.03.831c.216 9.605 5.234 10.159 5.45 10.159h.123c.215-.031 5.233-.554 5.449-10.159l-.031-.8z"/>' }
  })
);